<!--<div class="dhl-generic-dialog" mat-dialog-container>

  <div mat-dialog-title >
    <div class="d-flex align-items-center w-100">
      <img alt="g-modal-image" src="./assets/icons/ic_alert.svg" class="dhl-dialog-img" />

      <h2 color="red" class="dhl-dialog-title">
        ¡Aviso importante sobre los pagos por transferencia bancaria!
      </h2>
    </div>
    <div class="flex-shrink-1">
      <div class="position-absolute top-0 end-0 p-2">
        <button mat-icon-button color="accent">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div mat-dialog-content>
    <div class="row">
      <div class="col">
        A partir del 16 de Julio, los pagos por transferencia deberán realizarse únicamente a nuestra nueva cuenta bancaria.
        <br><br>
        La cuenta anterior dejará de estar operativa y no podrá recibir pagos.
        <br><br>
        Por favor, asegúrate de actualizar los datos en tus sistemas o procesos de pago para evitar inconvenientes.
        <br><br>
        Puedes consultar los nuevos datos bancarios en tu correo electrónico al momento de generar una orden de compra mediante la modalidad de pago con transferencia.
        <br><br>
        Gracias por tu atención y confianza.
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-end">
  </div>
</div>-->

<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <!--<img alt="g-modal-image" *ngIf="true" src="./assets/icons/ic_alert.svg" class="dhl-dialog-img" />-->
    <h2 color="red" class="dhl-dialog-title">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2">
      <button mat-icon-button [mat-dialog-close]="false" color="accent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col dhl-dialog-message" [innerHTML]="dialogData.message"></div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button *ngIf="dialogData.showCancel"
          mat-stroked-button
          color="accent"
          (click)="onCancel()"
          class="dhl-btn-secundary"
          [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'"></button>
  <button *ngIf="dialogData.showAccept" mat-flat-button cdkFocusInitial color="accent" (click)="onAccept()" class="dhl-btn-primary">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>
</div>



